"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrowDown = exports.arrowRight = exports.arrowUp = exports.arrowLeft = exports.home = exports.end = exports.pageDown = exports.pageUp = exports.space = exports.escape = exports.enter = exports.tab = void 0;
exports.tab = 9;
exports.enter = 13;
exports.escape = 27;
exports.space = 32;
exports.pageUp = 33;
exports.pageDown = 34;
exports.end = 35;
exports.home = 36;
exports.arrowLeft = 37;
exports.arrowUp = 38;
exports.arrowRight = 39;
exports.arrowDown = 40;
